const MAPBOX_TOKEN = 'pk.eyJ1IjoidmlyYWUiLCJhIjoib18za1RjTSJ9.sJJU5uLsfdBRISvyCT11RQ'

function createMarkerElement(imageUrl) {
  const div = document.createElement('div')
  div.className = 'circle-marker' // Add any additional styles you need
  div.style.backgroundImage = `url(${imageUrl})`
  div.style.width = '84px'
  div.style.height = '84px'
  div.style.backgroundSize = 'cover'
  return div
}

if (window.cfg.map_data) {
  $(document).ready(function() {

    mapboxgl.accessToken = MAPBOX_TOKEN

    const map = new mapboxgl.Map({
      container: 'map-container',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [19.142, 48.738277],
      zoom: 14
    })

    // Enable scroll zoom
    map.scrollZoom.enable()

    // Add navigation controls (zoom and rotation controls)
    map.addControl(new mapboxgl.NavigationControl())

    cfg.map_data.forEach(function(m) {
      if (m.lat && m.lon && m.image_url) {
        new mapboxgl.Marker({
          element: createMarkerElement(m.image_url),
          anchor: 'bottom'
        })
          .setLngLat([m.lon, m.lat])
          .setPopup(new mapboxgl.Popup().setHTML(`<a href='${m.url}' style='font-size: 16px;'><strong>${m.title}</strong><br>${m.author}</a>`))
          .addTo(map)
      }
    })
  })
}

export { MAPBOX_TOKEN }
